import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) {}

  /**
   * Centralized method to process Yoco payments
   * @param orderId - The order ID to process payment for
   * @returns Observable with the payment response
   */
  processYocoPayment(orderId: string): Observable<any> {
    console.log('PaymentService: Processing Yoco payment for order', orderId);
    
    const url = `payment/checkoutYoco?orderId=${orderId}`;
    const data = {
      webFailure: `${window.location.origin}/customer-payment-cancel`,
      webError: `${window.location.origin}/customer-payment-error`,
      webSuccess: `${window.location.origin}/customer-payment-success?orderId=${orderId}`,
      cancelUrl: `${window.location.origin}/customer-payment-cancel`,
      errorUrl: `${window.location.origin}/customer-payment-error`,
      successUrl: `${window.location.origin}/customer-payment-success?orderId=${orderId}`,
      testMode: true,
      trxFrom: 'WEB'
    };
    
    console.log('PaymentService: Sending request to', this.commonService.baseUrl + url);
    console.log('PaymentService: With data', JSON.stringify(data));
    
    return this.commonService.postApi(url, data, 1);
  }
  
  /**
   * Handle the Yoco payment response
   * @param response - The response from the Yoco payment API
   * @returns true if successful, false otherwise
   */
  handleYocoPaymentResponse(response: any): boolean {
    console.log('PaymentService: Handling Yoco payment response', response);
    
    if (response.responseCode === 200 || response.responseCode === 'SUCCESS') {
      if (response.result && response.result.checkoutUrl) {
        // If we have a direct redirect URL, use it
        console.log('PaymentService: Redirecting to Yoco checkout URL:', response.result.checkoutUrl);
        window.location.href = response.result.checkoutUrl;
        return true;
      } else if (response.result && response.result.file) {
        // If we have an HTML form, render it in the DOM
        console.log('PaymentService: Rendering HTML form from response');
        try {
          // Create a container for the form
          const formContainer = document.createElement('div');
          formContainer.innerHTML = response.result.file;
          document.body.appendChild(formContainer);
          
          // Find and submit the form
          setTimeout(() => {
            const form = document.getElementById('yoco-form');
            if (form) {
              console.log('PaymentService: Submitting Yoco form');
              (form as HTMLFormElement).submit();
              return true;
            } else {
              console.error('PaymentService: Yoco form not found in response');
              this.commonService.errorToast('Error processing payment. Please try again.');
              return false;
            }
          }, 500);
          return true;
        } catch (error) {
          console.error('PaymentService: Error rendering HTML form:', error);
          this.commonService.errorToast('Error processing payment. Please try again.');
          return false;
        }
      } else {
        console.error('PaymentService: Invalid response format:', response.result ? JSON.stringify(response.result) : 'Missing result');
        this.commonService.errorToast('Error processing payment. Please try again.');
        return false;
      }
    } else {
      console.error('PaymentService: Error response from backend:', JSON.stringify(response));
      this.commonService.errorToast(response.responseMessage || 'Error processing payment');
      return false;
    }
  }
} 